
<div class="form-input-container" [style]="style">

@if (readonly) {
  <label>{{label}}</label>
  <div  #container>
    <select class="floatSelect" [(ngModel)]="boundValue"  [disabled]="true">
      @for (item of options; track item) {
        <option [value]="item.id">{{item.name}}</option>
      }
    </select>      
  </div>
}
  
@if (!readonly) {
    @if (required) {
      <label>{{label}} *</label>
    }
    @else {
      <label>{{label}}</label>
    }
    <div  #container>
      @if (searchable) {
        <!--
          Custom dropdown instead of a native <select>: a search box can't live inside
          a <select> in Safari/Firefox (only Chromium's customizable select allows it).
        -->
        <div class="searchable-select">
          <button type="button" id="{{myId}}" class="searchable-select__trigger"
                  [class.is-invalid]="!isValid" [class.is-open]="dropdownOpen"
                  [disabled]="disabled"
                  aria-haspopup="listbox" [attr.aria-expanded]="dropdownOpen"
                  (click)="toggleDropdown()" (keydown)="onDropdownKeydown($event)">
            <span class="searchable-select__value" [class.is-placeholder]="!selectedName">{{ selectedName || placeholder }}</span>
            <svg class="searchable-select__chevron" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="grey" stroke-width="2" aria-hidden="true"><path d="M6 9L12 15L18 9"/></svg>
          </button>

          @if (dropdownOpen) {
            <div class="searchable-select__panel">
              <input #searchInput type="text" class="searchable-select__search" placeholder="Search..."
                     autocomplete="off" [value]="searchText"
                     (input)="onSearchInput($any($event.target).value)"
                     (keydown)="onDropdownKeydown($event)" />
              <ul class="searchable-select__list" role="listbox">
                @for (item of options; track item.id; let i = $index) {
                  <li role="option" class="searchable-select__option"
                      [class.is-active]="i === activeIndex"
                      [class.is-selected]="item.id === boundValue"
                      [attr.aria-selected]="item.id === boundValue"
                      (mouseenter)="activeIndex = i"
                      (click)="selectOption(item)">{{ item.name }}</li>
                } @empty {
                  <li class="searchable-select__empty">No results</li>
                }
              </ul>
            </div>
          }
        </div>
        <div class="validation-msg" [hidden]="isValid">{{validationMsg}}</div>
      } @else {
        <select [hidden]="multiple" class="form-input" style="width: 100%;" id="{{myId}}" #ddl [(ngModel)]="boundValue" [class.is-invalid]="!isValid" (change)="_handle_change($event)" (blur)="_handle_onBlur($event)" >
            @for (item of options; track item) {
            <option [value]="item.id">{{item.name}}</option>
            }
        </select>
        <select [hidden]="!multiple" class="form-input" style="height: 100%; width: 100%;" multiple id="{{myId}}" #ddl [class.is-invalid]="!isValid" [(ngModel)]="boundValue" (change)="_handle_change($event)" (blur)="_handle_onBlur($event)" >
            @for (item of options; track item) {
            <option [value]="item.id">{{item.name}}</option>
            }
        </select>
        <div class="validation-msg" [hidden]="isValid">{{validationMsg}}</div>
      }
    </div>
}

</div>